import script from "./Navigation.vue?vue&type=script&setup=true&lang=js"
export * from "./Navigation.vue?vue&type=script&setup=true&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=6049bb46&scoped=true&lang=scss"

import exportComponent from "/home/rlabrovi/Local Sites/vertikal/app/public/wp-content/plugins/climbing-card/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6049bb46"]])

export default __exports__